const PROTECTION_LABEL_SELECTOR = ".lazy-oaf-cart-drawer label[for*='mule-protection']";
const PROTECTION_TITLE_SELECTOR = ".lazy-oaf-cart-drawer [class*='logoTitle']";

const protectionLabelStyles = {
  margin: '0',
  padding: '0',
  'min-height': '20px',
  'justify-content': 'flex-start',
  gap: '8px',
  background: 'transparent',
  'border-radius': '0',
  'font-family': 'var(--font-brand-display--family)',
  'font-size': '16px',
  'font-weight': '500',
  'line-height': '19px',
  'letter-spacing': '0.05em',
};

const protectionTitleStyles = {
  'font-family': 'var(--font-brand-display--family)',
  'font-size': '18px',
  'font-weight': '500',
  'line-height': '21px',
  'letter-spacing': '0.05em',
};

/**
 * ProtectMyOrder writes inline `!important` type styles after its configured CSS.
 * Reapply only the presentation contract; the provider keeps the checkbox and cart behaviour.
 *
 * @param {ParentNode} root
 */
function normaliseProtectionTypography(root = document) {
  const targets = [
    ...Array.from(root.querySelectorAll(PROTECTION_LABEL_SELECTOR), (element) => [element, protectionLabelStyles]),
    ...Array.from(root.querySelectorAll(PROTECTION_TITLE_SELECTOR), (element) => [element, protectionTitleStyles]),
  ];

  for (const [element, styles] of targets) {
    for (const [property, value] of Object.entries(styles)) {
      if (
        element.style.getPropertyValue(property) === value &&
        element.style.getPropertyPriority(property) === 'important'
      ) {
        continue;
      }

      element.style.setProperty(property, value, 'important');
    }
  }
}

normaliseProtectionTypography();

const observer = new MutationObserver((records) => {
  if (records.some(({ target }) => target instanceof Element && target.closest('.lazy-oaf-cart-drawer'))) {
    normaliseProtectionTypography();
  }
});

observer.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['style'],
  childList: true,
  subtree: true,
});
